/**
 * Navigation Store - Lightweight custom routing
 * Handles page navigation without external router dependency
 */

import { create } from 'zustand';

export type PageType =
  | 'home'
  | 'account'
  | 'extension'
  | 'imprint'
  | 'privacy'
  | 'widget'
  | 'widget-react'
  | 'minimal-demo'
  | 'widgets';

interface NavigationState {
  currentPage: PageType;
  navigate: (page: PageType) => void;
}

export const useNavigationStore = create<NavigationState>((set) => ({
  currentPage: 'home',

  navigate: (page: PageType) => {
    // Update browser URL without reload
    let path: string;
    if (page === 'home') {
      path = '/';
    } else if (page === 'widget-react') {
      path = '/widget/react';
    } else {
      path = `/${page}`;
    }
    window.history.pushState({}, '', path);

    // Update store state
    set({ currentPage: page });

    // Scroll to top on navigation
    window.scrollTo(0, 0);
  },
}));

/**
 * Initialize navigation from current URL on app load
 */
export function initNavigationFromURL() {
  const path = window.location.pathname;
  const store = useNavigationStore.getState();

  if (path === '/account') {
    store.navigate('account');
  } else if (path === '/extension') {
    store.navigate('extension');
  } else if (path === '/imprint') {
    store.navigate('imprint');
  } else if (path === '/privacy') {
    store.navigate('privacy');
  } else if (path === '/widget/react' || path === '/widget') {
    store.navigate('widget-react');
  } else if (path === '/minimal-demo') {
    store.navigate('minimal-demo');
  } else if (path === '/widgets') {
    store.navigate('widgets');
  } else {
    store.navigate('home');
  }
}

/**
 * Handle browser back/forward buttons
 */
if (typeof window !== 'undefined') {
  window.addEventListener('popstate', () => {
    initNavigationFromURL();
  });
}
